import React, { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { Bot, Sparkles } from "lucide-react";
import { api, invalidate, toast, toastError } from "../lib";
import { Button, Field, Modal, cx } from "../ui";

export function NewProjectModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);
  const [, nav] = useLocation();
  useEffect(() => {
    if (open) (setName(""), setDescription(""));
  }, [open]);
  const submit = async () => {
    setBusy(true);
    try {
      const p = await api.post("/api/projects", { name, description });
      invalidate("/api/projects");
      onClose();
      nav(`/p/${p.slug}`);
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal open={open} onClose={onClose} title="Novo projeto" footer={<><Button variant="ghost" onClick={onClose}>Cancelar</Button><Button variant="primary" loading={busy} disabled={!name.trim()} onClick={submit}>Criar projeto</Button></>}>
      <Field label="Nome"><input className="input" autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && submit()} placeholder="Ex.: Contador, Highline, CVM" /></Field>
      <Field label="Descrição"><input className="input" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Opcional" /></Field>
    </Modal>
  );
}

export function NewTargetModal({ open, onClose, project, kind: initialKind = "prompt" }: { open: boolean; onClose: () => void; project: string; kind?: "prompt" | "agent" }) {
  const [kind, setKind] = useState<"prompt" | "agent">(initialKind);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);
  const [, nav] = useLocation();
  useEffect(() => {
    if (open) (setKind(initialKind), setName(""), setDescription(""));
  }, [open, initialKind]);
  const submit = async () => {
    setBusy(true);
    try {
      const t = await api.post(`/api/projects/${project}/targets`, { name, description, kind });
      invalidate("/api/projects");
      onClose();
      toast(kind === "agent" ? "Agente criado" : "Prompt criado", "edite o draft e salve a primeira versão");
      nav(`/p/${project}/t/${t.slug}`);
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  };
  const opt = (k: "prompt" | "agent", icon: React.ReactNode, title: string, text: string) => (
    <button type="button" onClick={() => setKind(k)} className="card" style={{ padding: 14, textAlign: "left", cursor: "pointer", borderColor: kind === k ? "var(--g8)" : undefined, background: kind === k ? "var(--surface-2)" : undefined }}>
      <div className="row" style={{ marginBottom: 6 }}>{icon}<b>{title}</b></div>
      <div className="muted" style={{ fontSize: 12.5 }}>{text}</div>
    </button>
  );
  return (
    <Modal open={open} onClose={onClose} title="Novo alvo" width={600} footer={<><Button variant="ghost" onClick={onClose}>Cancelar</Button><Button variant="primary" loading={busy} disabled={!name.trim()} onClick={submit}>Criar</Button></>}>
      <div className="grid-2">
        {opt("prompt", <span className="kind kind-prompt"><Sparkles size={13} /></span>, "Prompt", "Uma chamada de modelo: texto, JSON ou imagem, com entrada de texto ou imagem.")}
        {opt("agent", <span className="kind kind-agent"><Bot size={13} /></span>, "Agente", "Roda num sandbox com um contexto inteiro de arquivos. Stateless ou com sessão persistente.")}
      </div>
      <Field label="Nome"><input className="input" autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && submit()} placeholder={kind === "agent" ? "Ex.: Auditor de contratos" : "Ex.: Extrair nota fiscal"} /></Field>
      <Field label="Descrição"><input className="input" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="O que ele faz, em uma frase" /></Field>
    </Modal>
  );
}

// silencia import não usado em alguns bundlers
export const _cx = cx;
